import { defineComponent, toRef } from 'vue';
import { SurveyQuestion, SurveySubmissionAnswer } from '@studyportals/sp-lurch-interface';
import ReviewUploadModalQuestionComponent from '@/presentation/components/review-upload-modal-question/review-upload-modal-question-class';

export default defineComponent({
	props: {
		question: {
			type: Object as () => SurveyQuestion,
			required: true
		},
		answer: {
			type: Object as () => SurveySubmissionAnswer,
			required: false
		}
	},
	setup: (props, context) => {
		const component = new ReviewUploadModalQuestionComponent(
			context.emit,
			toRef(props, 'question'),
			toRef(props, 'answer')
		);

		return {
			question: component.question,
			answer: component.answer,
			isAnswerTypeMultiSelect: component.isAnswerTypeMultiSelect,
			isAnswerTypeNumber: component.isAnswerTypeNumber,
			storeQuestionAnswer: component.storeQuestionAnswer.bind(component),
			storeQuestionAnswerNumber: component.storeQuestionAnswerNumber.bind(component)
		};
	}
});
